<template>
  <v-dialog v-model="opened">
    <v-card class="basic-modal" elevation="4" width="560">
      <v-card-title class="d-flex justify-space-between">
        <h6 class="heading--text d-flex align-center">
          <v-icon size="24" class="mr-4" color="error"> $alertwarning </v-icon>
          <span> {{ $t("reseller.apiTokens.modal.delete.title") }}</span>
        </h6>
        <v-btn :style="submitting ? 'pointer-events: none;' : ''" icon x-small @click="close()">
          <v-icon size="24">$close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div>
          <v-form ref="form" class="d-flex flex-column">
            <div class="d-flex flex-column">
              <div class="last-child d-flex flex-column align-start w-100">
                <template>
                  <template>
                    <p class="p-2 mb-6">
                      <b>{{ $t("message.confirmAction") }}</b>
                    </p>
                      <Checkbox
                        outlined
                        :checked="confirm"
                        @change="confirm = $event"
                        :label="$t('reseller.apiTokens.removeToken')"
                        color="primary"
                        dense
                      />
                  </template>
                </template>
              </div>
            </div>
          </v-form>
        </div>
      </v-card-text>

      <v-card-actions class="d-flex justify-end">
        <v-btn
          :text="true"
          large
          elevation="0"
          class="normal"
          @click="!submitting && close()"
        >
          <span class="p-2 font-weight-bold gray--text text--darken-1">
            {{ $t("button.cancel") }}
          </span>
        </v-btn>
        <v-btn
          :text="false"
          large
          elevation="0"
          class="error"
          :class="!confirm ? 'disabled-gray' : ''"
          @click="submit()"
          :loading="submitting"
        >
          <span class="p-2 font-weight-600 text--white-base">{{ $t("button.delete") }}</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Api from "../../apis/Api";
import Checkbox from "@/components/buttons/Checkbox.vue";

export default {
  components: {
    Checkbox,
  },
  data() {
    return {
      opened: false,
      apiToken: null,
      confirm: false,
      submitting: false,
    };
  },
  methods: {
    open(apiToken) {
      this.opened = true;
      this.apiToken = { ...apiToken };
      this.confirm = false;
    },
    close() {
      this.opened = false;
    },
    submit() {
      this.submitting = true;
      Api.delete(`/reseller/api-tokens/${this.apiToken.id}`)
        .then((response) => {
          this.$emit("api-token-deleted", response.data.data);
          this.close();
        })
        .catch((error) => {
          this.$store.dispatch("addAlert", {
            success: false,
            errorMessage: Api.getErrorMessage(error),
          });
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
  watch: {
    // opened(opened) {
    //   if (opened) {
    //     this.$store.dispatch("lockBodyScroll");
    //     return;
    //   }
    //   this.$store.dispatch("unlockBodyScroll");
    // },
  },
};
</script>

<style src="@/components/modal/BasicModal.scss" lang="scss" scoped/>
